var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M141.935,95.095H56.731c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h85.139c6.012,0,10.925,4.848,10.925,10.925C152.796,90.246,147.947,95.095,141.935,95.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M228.367,155.927H56.731c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h171.636c6.012,0,10.925,4.848,10.925,10.925S234.38,155.927,228.367,155.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M228.367,216.76H56.731c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h171.636c6.012,0,10.925,4.848,10.925,10.925C239.293,211.782,234.38,216.76,228.367,216.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M139.091,277.463h-82.36c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h82.36c6.012,0,10.925,4.848,10.925,10.925C150.016,272.614,145.167,277.463,139.091,277.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M113.232,338.295H56.731c-6.012,0-10.925-4.848-10.925-10.925s4.848-10.925,10.925-10.925h56.501 c6.012,0,10.925,4.848,10.925,10.925C124.222,333.382,119.244,338.295,113.232,338.295z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M215.826,351.418l-48.356,10.731c-3.556,0.646-6.982,0-10.02-2.909 c-2.651-2.651-3.685-6.4-2.909-10.02l10.731-48.356c0.453-2.004,1.487-3.879,2.909-5.301l95.224-95.224V100.137h-67.232 c-6.012,0-10.925-4.848-10.925-10.925V21.98H32.812c-6.012,0-10.925,4.848-10.925,10.925v327.111 c0,6.012,4.848,10.925,10.925,10.925h219.604c6.012,0,10.925-4.848,10.925-10.925v-53.527l-42.085,42.085 C219.705,349.931,217.83,350.966,215.826,351.418z M56.731,73.309h85.139c6.012,0,10.925,4.848,10.925,10.925 c0,6.077-4.848,10.925-10.925,10.925H56.731c-6.012,0-10.925-4.848-10.925-10.925C45.871,78.158,50.719,73.309,56.731,73.309z M56.731,134.141h171.636c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H56.731 c-6.012,0-10.925-4.848-10.925-10.925C45.871,138.99,50.719,134.141,56.731,134.141z M56.731,194.844h171.636 c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H56.731c-6.012,0-10.925-4.848-10.925-10.925 C45.871,199.822,50.719,194.844,56.731,194.844z M113.232,338.295H56.731c-6.012,0-10.925-4.848-10.925-10.925 s4.848-10.925,10.925-10.925h56.501c6.012,0,10.925,4.848,10.925,10.925C124.222,333.382,119.244,338.295,113.232,338.295z M139.091,277.527h-82.36c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925h82.36 c6.012,0,10.925,4.848,10.925,10.925C150.016,272.614,145.167,277.527,139.091,277.527z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#56ACE0"
    },
    points: "247.826,78.287 206.969,37.301 206.969,78.287 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M185.765,308.622l-6.335,28.509l28.509-6.335l159.935-159.935c4.655-4.655,3.426-13.576-2.651-19.653 c-6.077-5.947-14.61-7.434-19.653-2.65L185.765,308.622z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M56.731,95.095h85.139c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 H56.731c-6.012,0-10.925,4.848-10.925,10.925C45.871,90.246,50.719,95.095,56.731,95.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M56.731,155.927h171.636c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 H56.731c-6.012,0-10.925,4.848-10.925,10.925C45.871,151.079,50.719,155.927,56.731,155.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M56.731,216.76h171.636c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 H56.731c-6.012,0-10.925,4.848-10.925,10.925C45.871,211.846,50.719,216.76,56.731,216.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M139.091,255.677h-82.36c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h82.36c6.012,0,10.925-4.848,10.925-10.925C150.016,260.655,145.167,255.677,139.091,255.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M113.232,316.509H56.731c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h56.501c6.012,0,10.925-4.848,10.925-10.925C124.222,321.358,119.244,316.509,113.232,316.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M380.739,135.822c-13.123-13.446-35.103-17.002-50.489-2.651l-45.188,45.188V89.147 c0-2.844-1.164-5.624-3.168-7.758L203.673,3.168C201.669,1.164,198.889,0,195.915,0H32.812C14.711,0,0.036,14.675,0.036,32.711 v327.111c0,18.101,14.675,32.776,32.776,32.776h219.604c18.036,0,32.711-14.675,32.711-32.711v-75.313l98.263-98.263 C396.578,173.059,395.414,150.432,380.739,135.822z M247.826,78.287H206.84V37.301L247.826,78.287z M263.277,359.887 c0,6.012-4.848,10.925-10.925,10.925H32.812c-6.012,0-10.925-4.848-10.925-10.925V32.776c0-6.012,4.848-10.925,10.925-10.925 h152.372v67.232c0,6.012,4.848,10.925,10.925,10.925h67.232v100.331l-95.224,95.16c-1.487,1.487-2.457,3.297-2.909,5.301 l-10.731,48.356c-0.776,3.62,0.323,7.434,2.909,10.02c3.103,2.909,6.465,3.556,10.02,2.909l48.356-10.731 c2.004-0.453,3.879-1.487,5.301-2.909l42.085-42.085v53.527H263.277z M367.939,170.925l-160,159.935l-28.509,6.335l6.335-28.509 l159.935-159.935c5.042-4.784,13.446-3.297,19.653,2.651C371.43,157.285,372.594,166.271,367.939,170.925z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocument);
export default __webpack_public_path__ + "static/media/fileDocument.1b0c7409adfed4c3211b75c3d701a643.svg";
export { ForwardRef as ReactComponent };